'use strict';

exports['default'] = {
  isMac: function isMac() {
    return typeof window !== 'undefined' && window.navigator && /Mac/.test(window.navigator.platform);
  },
  isWin: function isWin() {
    return typeof window !== 'undefined' && window.navigator && /Win/.test(window.navigator.platform);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/browser.js
// module id = 535
// module chunks = 0